export function showResellerNote(parent) {
  const resellerNote = parent.querySelector("[data-reseller-note]");
  const countryDropdown = document.querySelector("#id_country");
  if (resellerNote && countryDropdown) {
    resellerNote.hidden = true;
    const countryCode = countryDropdown.value;
    const countryName =
      countryDropdown.options[countryDropdown.selectedIndex].textContent;
    const hostname =
      location.hostname === "shop.bitbox.swiss"
        ? "bitbox.swiss"
        : document.body.dataset.websiteurl;

    fetch("/api/resellers/")
      .then((data) => data.json())
      .then((data) => data.resellers || [])
      .then((resellers) =>
        resellers.filter((reseller) => reseller.shop_note === true)
      )
      .then((resellers) =>
        resellers.filter((reseller) =>
          (reseller.country_codes || []).includes(countryCode)
        )
      )
      .then((resellers) => {
        if (resellers.length) {
          resellerNote.hidden = false;
          const resellerLink = document.querySelector("[data-reseller-link]");
          resellerLink.href = `https://${hostname}/buy/?search=${encodeURIComponent(
            countryName
          )}`;
        }
      })
      .catch(() => {
        resellerNote.hidden = true;
      });
  }
}

showResellerNote(document.body);
